import { IGeneralState, GeneralAction } from '../../@types/redux';
import Actions from './actions';
import { getType } from 'typesafe-actions';

const initialState : IGeneralState = {
    notifications: [],
};

export default function generalReducer(state : IGeneralState = initialState, action : GeneralAction) : IGeneralState {
    switch (action.type) {
        case getType(Actions.enqueueSnackbar):
            return { ...state, notifications: [
                ...state.notifications,
                {
                    ...action.payload,
                },
            ] };
        case getType(Actions.removeSnackbar):
            return { ...state,
                notifications: state.notifications.filter(
                    notification => notification.key !== action.payload,
                ) };
        default:
            return state;
    }
}
